import type { RoleKey } from '@/stores/unitStore'

export function hasAnyRole(roles: string[], allowed: RoleKey[]) {
  return allowed.some((role) => roles.includes(role))
}

export function getAccessFlags(roles: string[]) {
  const isAdmin = hasAnyRole(roles, ['owner', 'admin_rede'])
  const isManager = isAdmin || roles.includes('gerente_unidade')
  const isSupervisor = isManager || roles.includes('supervisor')
  const isEmployee = roles.includes('employee')
  // Atendente de expedição (F2.1): opera a expedição de motoboys à noite.
  // Home = /app/expedicao; sem dashboard, fechamento diário ou cadastros.
  const isExpedicaoAttendant = roles.includes('atendente_expedicao')
  const isExpedicaoOnly = isExpedicaoAttendant && !isSupervisor
  const isEmployeeOnly = isEmployee && !isSupervisor && !isExpedicaoAttendant

  return {
    isAdmin,
    isManager,
    isSupervisor,
    isEmployee,
    isEmployeeOnly,
    isExpedicaoAttendant,
    isExpedicaoOnly,
    canViewDashboard: isSupervisor,
    canUseClosing: isSupervisor,
    canUseTeamModules: isSupervisor,
    canUseExpedicao: isSupervisor || isExpedicaoAttendant,
    canUseFinance: isManager,
    canUseReports: isSupervisor,
    canManageUsers: isManager,
    canUseSystemAdmin: isAdmin,
  }
}

/**
 * Aggregate all roles across all units the user has access to.
 * Used when the user is in "All units" mode (selectedUnitId === null).
 */
export function getAllUnitsAccessFlags(rolesByUnit: Record<string, string[]>) {
  const allRoles = new Set<string>()
  for (const roles of Object.values(rolesByUnit)) {
    for (const r of roles) allRoles.add(r)
  }
  return getAccessFlags(Array.from(allRoles))
}

/**
 * Whether the user is allowed to opt into "All units" mode.
 * Only owner / admin_rede in any unit can use it.
 */
export function canUseAllUnitsMode(rolesByUnit: Record<string, string[]>): boolean {
  return Object.values(rolesByUnit).some(rs => rs.includes('owner') || rs.includes('admin_rede'))
}
